const [ w, d, l, content ] = [ window, document, location, 'service' ]

const detail_init = post_id => {
  // 記事取得
  const iconNameTable = {
    1: 'shikin',
    2: 'keiei',
    3: 'kigyou',
    4: 'price'
  }
  $.getArticles({ content, post_id }).then( the_article => {
    the_article = the_article.shift()
    let $head = $(`
      <section class="${content}-head is-service-${iconNameTable[post_id]}">
        <h3 class="${content}-head__title">
          <svg class="icon is-icon-${iconNameTable[post_id]}" width="25" height="20"><use xlink:href="/asset/svg/sprite.symbol.svg#icon-${iconNameTable[post_id]||'shikin'}"></use></svg>
          <span>${the_article.title}</span>
        </h3>
        <!-- /.${content}-head__title -->
      </section>
      <!-- /.${content}-head -->
    `)
    $('.element_detail > .title, .detail_title').remove()
    $head.insertAfter('.mainImg')
  })

}

const init = () => {
  $.when(
    w.load['nav-service-head'],
    w.load['nav-service-foot']
  ).then( () => $('[data-plugin="currentMenu"]').currentMenu() )
}

export default function SERVICE () {
  $(() => {
    init()
    if( d.body.classList.contains('is--detail') ) {
      let post_id = d.body.classList.value.replace(/^(.+)?is--article-([\d]+)(.+)?$/,'$2')
      detail_init( parseInt( post_id ) )
    }
  })
}